








import Vue from "vue";
import { Component } from "vue-property-decorator";
import { CountryDto } from "@/api/ClientPortalApiClient";
import ApiFactory from "../../api/ApiFactory";

@Component({})
export default class CbxCountry extends Vue {
  private types: CountryDto[] | null = [];
  public selectedType = new CountryDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: CountryDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: CountryDto) {
    this.$emit("countrySelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .country_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
